<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'

import codeEditorService from '@/services/embeds/plugin/code.editor.service'
import fontSizeService from '@/services/embeds/plugin/font.size.service'
import { useIdeStore } from '@/stores/embeds/ide.store'
import { useEmbedConfigureStore } from '@/stores/embeds/embedConfigure.store'

const ideStore = useIdeStore()
const embedConfigStore = useEmbedConfigureStore()

const { getOnEditMode } = storeToRefs(embedConfigStore)

const { getFontSizeHideTitle, getFontSizeTitleName, getFontSizeDisplay } = storeToRefs(ideStore)

/**
 * @description on select language
 */
const onSelectFontSizeChange = () => {
  codeEditorService.codeEditorSetFontSize()
}

onMounted(async () => {
  await new Promise((resolve) => setTimeout(resolve, 100))
  if (getOnEditMode.value === false) {
    fontSizeService.initFontSize()
    fontSizeService.onSettingChange()
  }
})
onBeforeUnmount(async () => {
  if (getOnEditMode.value === false) {
    await fontSizeService.destroyFontSize()
  }
  await new Promise((resolve) => setTimeout(resolve, 100))
})
</script>

<template>
  <div
    :class="[
      'flex h-full w-full gap-2 ',
      {
        'flex-col': !getFontSizeDisplay
      },
      {
        'flex-row items-center': getFontSizeDisplay
      }
    ]"
  >
    <label v-if="getFontSizeHideTitle" class="min-w-fit font-semibold leading-6">
      {{ getFontSizeTitleName }}</label
    >
    <select
      class="block h-12 w-full rounded-md border border-gray-400 px-2 outline-none"
      v-model="ideStore.fontSize"
      @change="onSelectFontSizeChange()"
    >
      <option
        v-for="fontSize in Array.from({ length: 15 }, (_, i) => i + 11)"
        :key="fontSize"
        :value="fontSize"
      >
        {{ fontSize }}px
      </option>
    </select>
  </div>
</template>
